import React, { createContext, useState, useEffect, useCallback } from 'react'
import {
    setCurrencyFactor,
    loadCalculator
} from '../../model/calculator/calculator'
import api from '../../client'
/*import { auth } from '../../model/db/db'*/

export const CalculatorContext = createContext()

const CalculatorProvider = ({ children }) => {
    //const [user, setUser] = useState(null)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(true)
    const [currency, setCurrency] = useState('eur')
    const [tooltips, setTooltips] = useState(null)

    const handleSetCurrency = useCallback((value) => {
        setCurrencyFactor(value)
        setCurrency(value)
    }, [])

    useEffect(() => {
        /*let unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                setLoading(true)
                await loadCalculator()
                setUser(user)
                setCurrencyFactor(currency)
            }
            setLoading(false)
        })*/

        ;(async () => {
            setLoading(true)
            try {
                await loadCalculator()
                setCurrencyFactor(currency)

                const tooltips = await api.product.getDescriptions()
                setTooltips(tooltips)
                console.log(tooltips)
                setLoading(false)
            } catch (error) {
                setError(error.message)
            }
        })()

        /*return () => {
            unsubscribe()
        }*/
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <CalculatorContext.Provider
            value={{
                currency,
                setCurrency: handleSetCurrency,
                //user,
                loading,
                error,
                tooltips
            }}
        >
            {children}
        </CalculatorContext.Provider>
    )
}

export default CalculatorProvider
